import React from 'react';
import {Button, Card, Col, Form, Input,InputNumber, Modal, Radio, Row, Table} from 'antd';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl-context';
import {
    getPelLeagueDictionaries,
    getPelPlayerRankList,
    getPelTeamRankIntegral,
    getPelTeamRankWeeklyIntegral,
    getSortFieldDictionaries, updatePelPlayerRank,
    updatePelTeamRankIntegral,
    updatePelTeamRankWeeklyIntegral
} from "../../modules/training/action";
import PelDataPlayerFilter from "./components/PelDataPlayerFilter";

const {confirm} = Modal;

class PelDataPlayerManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            page: 1,
            size: 10,
            pelLeagueType: null,
            pelLeagueStage: null,
            dataType: null,
            edition: false,
            updatePelPlayerRankDate: null,
            sortField: null,
        };
    }

    componentWillMount() {
        this.onInitData();
    }

    onInitData = async (props = this.props) => {
        const {getPelLeagueDictionaries, getPelTeamRankIntegral, getSortFieldDictionaries, getPelPlayerRankList} = props;
        await getPelLeagueDictionaries().then((data1) => {
            if(data1 && data1.length == 0)return;
            getSortFieldDictionaries({
                leagueBrandType: 'PEL',
                rankType: 'PLAYER',
                rankDataType: 'TOTAL'
            }).then((data) => {
                getPelPlayerRankList({page: 1, size: 10, pelLeagueType: data1[0].value, sort: data[0].value})
                this.setState({
                    pelLeagueType: data1[0].value,
                    sortField: {key: data[0].key, value: data[0].value},
                    dataType: 'TOTAL',
                    updatePelPlayerRankDate: null
                })
            })
        }).catch(error => {
        });
    }

    //刷新界面数据
    onGetTableData = () => {
        const {getPelPlayerRankList} = this.props;
        const {sortField, pelLeagueType, page, size} = this.state;
        this.setState({
            loading: true,
            updatePelPlayerRankDate: null
        })
        getPelPlayerRankList({page: page, size: size, pelLeagueType: pelLeagueType, sort:sortField.value})
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.pelPlayerRankList !== this.props.pelPlayerRankList) {
            this.setState({
                loading: false
            })
        }
    }

    onPageChangeEvent = (current, pageSize) => {
        const {getPelPlayerRankList} = this.props;
        const {pelLeagueType, sortField} = this.state;
        getPelPlayerRankList({page: current, size: pageSize, pelLeagueType: pelLeagueType, sort: sortField.value})
        this.setState({
            page: current,
            size: pageSize,
            loading: true,
            edition: false,
            updatePelPlayerRankDate: null
        });
    }

    onBtnClick = (type) => {
        if (type === true) {
            this.setState({
                edition: type,
            });
        } else {
            let _this = this;
            confirm({
                content: '确认要保存本次修改吗?',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    _this.onSavePelData(type)
                },
                onCancel() {
                },

            });
        }
    }

    onSavePelData = async (type) => {
        const {updatePelPlayerRankDate} = this.state;
            const {updatePelPlayerRank} = this.props;
            console.log(updatePelPlayerRankDate)
            if(!updatePelPlayerRankDate)return;
            await updatePelPlayerRank(updatePelPlayerRankDate).then((data) => {
            }).catch(error => {
            })
        await this.onGetTableData()
        await this.setState({
            edition: type,
        });
    }

    onBtnCancelClick = (type) => {
        let _this = this;
        confirm({
            content: '确认要取消编辑吗?',
            okText: '确认',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
                _this.setState({
                    edition: type,
                });
            },
            onCancel() {
            },

        });
    }

    renderTableTitle = () => (
        <Row type="flex" justify="end">
            <Col>
                <Button type="primary"
                        onClick={() => this.onBtnClick(!this.state.edition)}>{this.state.edition ? `保存` : `编辑`}</Button>
                {this.state.edition ? <Button type="primary" style={{marginLeft: 20}}
                                              onClick={() => this.onBtnCancelClick(!this.state.edition)}>撤销</Button> : null}
            </Col>
        </Row>
    )

    //条件查找动态方法
    onFilterPelDataPlayerEvent = async (pelLeagueType, dataType) => {
        const {size} = this.state;
        const {getSortFieldDictionaries, getPelPlayerRankList} = this.props;
        getSortFieldDictionaries({
            leagueBrandType: 'PEL',
            rankType: 'PLAYER',
            rankDataType: dataType
        }).then((data) => {
            getPelPlayerRankList({page: 1, size: size, pelLeagueType: pelLeagueType, sort: data[0].value})
            this.setState({
                pelLeagueType: pelLeagueType,
                sortField: data[0],
                dataType: dataType,
                page: 1,
                edition: false,
                updatePelPlayerRankDate: null
            })
        })
    }

    onChangeRadio = e => {
        const {sortFieldDicList, getPelPlayerRankList} = this.props;
        let field = sortFieldDicList.filter(item => item.value === e.target.value);
        getPelPlayerRankList({
            page: 1,
            size: this.state.size,
            pelLeagueType: this.state.pelLeagueType,
            sort: e.target.value,
            updatePelPlayerRankDate: null
        })
        this.setState({
            sortField: field.length > 0 ? field[0] : this.state.sortField,
            page: 1
        });
    };

    render() {
        const {
            pelPlayerRankList, sortFieldDicList
        } = this.props;
        const {
            page, size, loading, sortField
        } = this.state;
        const radioStyle = {
            display: 'block',
            marginBottom: '5px',
            height: '40px',
            width: '120px',
            lineHeight: '40px',
            textAlign: 'center'
        };
        return (
            <div>
                <Card style={{marginBottom: 30}}>
                    <PelDataPlayerFilter dataSource={{...this.props}} onCommit={this.onFilterPelDataPlayerEvent}/>
                </Card>
                <Card>
                    <Row>
                        <Col span={2}>
                            <Radio.Group onChange={this.onChangeRadio}
                                         value={sortField ? sortField.value : sortFieldDicList ? sortFieldDicList[0].value : null}
                                         buttonStyle="solid">
                                {sortFieldDicList && sortFieldDicList.map((item) => <Radio.Button style={radioStyle}
                                                                                                  value={item.value}>{item.key}</Radio.Button>)}
                            </Radio.Group>
                        </Col>
                        <Col span={22}>
                            <Table
                                dataSource={pelPlayerRankList ? pelPlayerRankList.data : []}
                                title={this.renderTableTitle}
                                columns={this.getAllTableColumns()}
                                bordered
                                pagination={{
                                    total: pelPlayerRankList ? pelPlayerRankList.total : 0,
                                    current: page,
                                    pageSize: size,
                                    onChange: this.onPageChangeEvent,
                                    showTotal: (total) => {
                                        return `总计 ${total}条数据`;
                                    }
                                }}
                                loading={loading}
                            />
                        </Col>
                    </Row>
                </Card>
            </div>)
    }


    onChangeTable = (key, row, value) => {
        const {pelPlayerRankList} = this.props;
        let {updatePelPlayerRankDate} = this.state;
        if (!updatePelPlayerRankDate) {
            console.log("updatePelPlayerRankDate")
            updatePelPlayerRankDate = JSON.parse(JSON.stringify(pelPlayerRankList.data));
        }
        updatePelPlayerRankDate[row][key] = value.target.value;
        this.setState({updatePelPlayerRankDate: updatePelPlayerRankDate})
    }

    getAllTableColumns = () => {
        const {getFieldDecorator} = this.props.form;
        const {sortField, dataType} = this.state;
        console.log(sortField)
        let columns = [
            {
                title: '排名',
                dataIndex: 'rank',
                key: 'rank',
                align: 'center',
            },
            {
                title: '玩家展示ID',
                dataIndex: 'exhibitionId',
                key: 'exhibitionId',
                align: 'center',
                render: (index, text, row) => {
                    return (this.state.edition ?
                        <div>
                            <Form.Item style={{margin: 0}}>
                                {getFieldDecorator('exhibitionId' + row, {
                                    initialValue: text.exhibitionId ? text.exhibitionId : null,
                                })(<Input style={{width: 120}}
                                                onChange={(e) => this.onChangeTable('exhibitionId', row, e)}/>)}
                            </Form.Item>
                        </div> : text.exhibitionId)
                },
            },
            {
                title: '选手',
                dataIndex: 'playerName',
                key: 'playerName',
                align: 'center',
                render: (row, text) => {
                    return (<div><img width={33} height={33} src={text.playerIcon}/><span>{text.playerName}</span></div>)
                }
            },
            {
                title: '队伍展示ID',
                dataIndex: 'teamShowId',
                key: 'teamShowId',
                align: 'center',
                render: (index, text, row) => {
                    return (this.state.edition ?
                        <div>
                            <Form.Item style={{margin: 0}}>
                                {getFieldDecorator('teamShowId' + row, {
                                    initialValue: text.teamShowId ? text.teamShowId : null,
                                })(<Input style={{width: 120}}
                                                onChange={(e) => this.onChangeTable('teamShowId', row, e)}/>)}
                            </Form.Item>
                        </div> : text.teamShowId)
                },
            },
            {
                title: '所属战队',
                dataIndex: 'gfTeamName',
                align: 'center',
                key: 'gfTeamName',
                render: (row, text) => {
                    return (<div><img width={33} height={33} src={text.gfTeamIcon}/><span>{text.gfTeamName}</span></div>)
                }
            }];
        if (sortField) {
            columns.push({
                title: `${sortField.key}`,
                dataIndex: `${sortField.value}`,
                key: `${sortField.value}`,
                align: 'center',
                render: (index, text, row) => {
                    return (this.state.edition ?
                        <div>
                            <Form.Item style={{margin: 0}}>
                                {getFieldDecorator(`${sortField.value}` + row, {
                                    initialValue: text[`${sortField.value}`],
                                    rules: [
                                        {
                                            required: true,
                                            message: `总积分不能为空.`,
                                        },
                                    ],
                                })(<Input
                                    onChange={(e) => this.onChangeTable(`${sortField.value}`, row, e)}/>)}
                            </Form.Item>
                            {/*</div> : text[`${sortField.value}`])*/}
                        </div> : dataType === 'AVG' ? (sortField.value === 'avgWinCount' || sortField.value === 'avgTop5Count' || sortField.value === 'avgHighHurtRatio' || sortField.value === 'avgHitRatio' ?
                            text[`${sortField.value}`] ? (text[`${sortField.value}`] * 100).toFixed(2) + '%' : '0%' :
                            text[`${sortField.value}`] ? (text[`${sortField.value}`] * 100).toFixed(2) : 0)
                            : text[`${sortField.value}`])
                },
            })
        }
        return (columns)
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.PartnerTraining,
        ...state.Team,
        ...state.Brand,
        ...state.viewTraining,
    }
};

const mapDispatchToProps = ({
    getPelTeamRankIntegral,
    getPelTeamRankWeeklyIntegral,
    updatePelTeamRankIntegral,
    updatePelTeamRankWeeklyIntegral,
    getPelLeagueDictionaries,
    getSortFieldDictionaries,
    getPelPlayerRankList,
    updatePelPlayerRank,
});

export default connect(
    mapStateToProps, mapDispatchToProps,
)(injectIntl(Form.create()(PelDataPlayerManagement)));
